// prettier-ignore
export const loginAuthenticate = {
  loginAuthenticateHeader: "Verify Login",
  loginAuthenticateButtonText: "Request Verification Code",
  loginAuthenticateText: "Select method to receive code",
  loginAuthenticateMessage: (mfaMethod: string, mfaAccount: string) => `Enter the code we sent to your ${mfaMethod} ${mfaAccount} below.`,
  loginAuthenticateVerifyButtonText: "Submit"
};
